import commonConfig from "./common.config";

export default {
  ...commonConfig,
  dailyPlatformUrl: 'https://frontm.daily.co/',
  daily_baseUrl: 'https://gq2d9i1b2c.execute-api.us-east-1.amazonaws.com/item/video',
  xApiKey: process.env.REACT_APP_X_API_KEY,
  userImageBaseUrl: "https://gw.frontm.ai/proxy/resource/file/profile-pics",
  defaultHomePagebaseUrl: "spinnet5.frontm.ai",
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  jwtLoginURL: 'https://8ojwj18vtd.execute-api.us-east-1.amazonaws.com/prod',
  xApiKeyForJwtLogin: process.env.REACT_APP_X_API_KEY_JWT_LOGIN,
  wpsGatewayRestApiKey: "https://api.frontm.ai/v5",
  websocketURL : 'wss://fffsczccvc.execute-api.us-east-1.amazonaws.com/production',
  webSocketAPiKey : process.env.REACT_APP_WEBSOCKET_API_KEY,
  //Apptypes
  vikandWebAppType: "vikand",
  stationoneAppType: "stationsatcom",
  onshipAppType: "onship",
  seamedexAppType: "seamedix",
  seadanceAppType: "seadance",
  intelsatAppType: "intelsat",
  //authCode
  onshipDomain: 'onshipEndUser',

  //webPushKeys
  seamedexWebPushKey: process.env.REACT_APP_SEAMEDEX_WEB_PUSH_KEY,
  vikandWebPushKey: process.env.REACT_APP_VIKAND_WEB_PUSH_KEY,
  dailyXApiKey: process.env.REACT_APP_DAILY_X_API_KEY,

};
